import loadScriptService from "../../_services/loadScriptService";
import powerReviewsService from "./powerReviewsService";
import "./loadProductReviewsSchema";

loadScriptService({
    url: 'https://ui.powerreviews.com/stable/4.1/ui.js',
    delay: 3000,
    callback: function () {
        window.pwr = window.pwr || function () {
            (pwr.q = pwr.q || []).push(arguments);
        };
         pwr("render", {
            enable_content_collection_modal: false,
            ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
            api_key: ''+window.spdc.vendor.prApiKey+'',
            locale: 'en_US',
            merchant_group_id: ''+window.spdc.vendor.prMerchGroupId+'',
            merchant_id: ''+window.spdc.vendor.prMerchId+'',
            page_id: ''+window.tbg.product.listId+'',
            review_wrapper_url: '/review?pr_page_id='+window.tbg.product.listId+'',
                on_render: unHideDelayed(),
            components: {
                ReviewSnippet: 'pr-reviewsnippet',
                ReviewSnapshot: 'pr-reviewsnapshot',
                ReviewList: 'pr-reviewlist',
                ReviewImageDisplay: 'pr-reviewimagedisplay',
                QuestionSnippet: 'pr-questionsnippet',
                QuestionDisplay: 'pr-questiondisplay'
            }
        });

        function unHideDelayed () {
            const reviewSnapshot = document.getElementById('pr-reviewsnapshot')
            const reviewList = document.getElementById('pr-reviewlist');
            const reviewImageDisplay = document.getElementById('pr-reviewimagedisplay');

            checkForNoReviews(reviewSnapshot, reviewList, reviewImageDisplay);
            document.getElementById('pr-reviewsnippet')?.classList.add('isLoaded');
            reviewList.classList.remove('isDelayed');
            reviewSnapshot.classList.remove('isDelayed');
            reviewImageDisplay.classList.remove('isDelayed');
        }

        function checkForNoReviews (reviewSnapshot, reviewList, reviewImageDisplay) {
            powerReviewsService.getReviewsForProduct(window.tbg.product.listId)
                .then(results => {
                    if (results.paging.total_results === 0) {
                        reviewSnapshot.removeAttribute('style');
                        reviewList.removeAttribute('style');
                    }
                });
        }

    }
});
